import { useEffect } from 'react';

import { isBrowser } from '../helpers/is-browser';

export interface IGtmParameters {
  [parameter: string]: string | boolean | undefined;
}

export const useSendGtmEvent = (params: IGtmParameters) => {
  useEffect(() => {
    if (isBrowser && dataLayer) {
      dataLayer.push(params);
    }
    // If "params" is added to the dependency array, it will cause the code to execute on window resize on detail pages. LW-1743
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
